/* Utils */
import { useState } from 'react';

/* Store */
import useModalsStore from 'Stores/Modals';
import useOrdersStore from 'Stores/Orders';

/* Components */
import Modal from 'Components/Modal';
import FormInput from 'Components/FormInput';

/* Styles */
import './style.scss';

const AddNote = (props) => {
	const hideModal = useModalsStore(state => state.hideModal);
	const addNote = useOrdersStore(state => state.addNote);
	const addingNote = useOrdersStore(state => state.addingNote);
	const { params: { order } } = props;
	const isEdit = order.details.internalNotes.length > 0 || false;

	const [form, setForm] = useState({
		note: isEdit ? order.details.internalNotes[0].content : ''
	});
	const [errors, setErrors] = useState({});

	const validateForm = () => {
		const newErrors = {};

		if (!form.note) {
			newErrors.note = { message: 'Remplir le champs' };
		}

		return newErrors;
	};

	const handleSubmit = async () => {
		const hasErrors = validateForm();
		setErrors(hasErrors);

		if (Object.keys(hasErrors).length > 0) {
			return;
		}

		const isSuccess = await addNote({ order, note: form.note });

		if (isSuccess) {
			hideModal();
		}
	};

	const navigation = { icon: 'utilitary_close', action: () => hideModal() };
	const button = { label: addingNote ? null : 'Envoyer', action: () => handleSubmit(), isLoading: addingNote };
	return (
		<Modal title={`Commande #${Util.getOrderNumber(order)}`} navigation={navigation} button={button}>
			<div className="sent-modal wrapper">
				<div className="sent-modal-content">
					<p className="title">{`${isEdit ? 'Modifier la' : 'Ajouter une'} note interne`}</p>
					<div className="inputs">
						<FormInput
							name="note"
							label="Note"
							placeholder="Ex: nouvelle longueur 45cm"
							value={form.note}
							setValue={(value) => setForm({ ...form, note: value })}
							errors={errors}
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
};

AddNote.propTypes = {
	params: PropTypes.shape({
		order: PropTypes.object.isRequired
	}).isRequired
};

export default AddNote;
